
import { getAxiosInstance } from "../../../api";

  export const createNew = async (data) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("admin/short/store",data);
      return response;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getDataById = async (id) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`admin/short/edit?_id=${id}`);
      return response;
    } catch (error) {
      return error.response.data;
    }
  };
  export const getSearchData = async (searchData) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`admin/short/video-list?search=${searchData}`);
      return response;
    } catch (error) {
      return error.response.data;
    }
  };
 